const modMin = item => {
  return item.mod_min == null || `${item.mod_min}`.trim() == ''
    ? null
    : parseInt(item.mod_min, 10);
};

export default modMin;
